import MyOrganizeTree from './organizeTree.vue';

MyOrganizeTree.install = function(Vue){
  Vue.component('MyOrganizeTree', MyOrganizeTree);
};

export default MyOrganizeTree;